// extracted by mini-css-extract-plugin
export default {"message":"Confirmation_message__nmLV5"};